<template>
  <div id="unitRightThree" class="echarts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { keyunit } from "@/api/dataAnalysis/unitOfAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      regionId: 0,
      name: [],
      value: [],
      obj: [],
    });
    const refData = toRefs(data);
    const keyunitlist = async () => {
      const res = await keyunit(data.regionId);
      data.obj = res.data;
    };
    onMounted(async () => {
      await keyunitlist();
      data.regionId = JSON.parse(localStorage.getItem("regionId"));
      // echarts项目初始化
      const myChart = echarts.init(document.getElementById("unitRightThree"));
      myChart.setOption({
        color: ["#ee6666", "#5470c6"],
        // title: {
        //   text: "Referer of a Website",
        //   subtext: "Fake Data",
        //   left: "center",
        // },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            data: data.obj,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
    return {
      ...refData,
    };
  },
});
</script>
<style lang="scss" scoped>
#unitRightThree {
  width: 100%;
  height: 90%;
}
</style>
